import axios from 'axios';
import "./interceptors";

// Talent (role) and producer-genre lookups for the user editor. A dead
// `getProfile` used to live here too, calling `users/profile` — a path the
// new API never had, so it 404'd on every call — reachable only through a
// default export nothing imported.

export function getUsersTalents() {
  return dispatch => {
    return axios.get(`api/v1/roles`).then(res => {
      dispatch({
        type: "GET_USER_TALENTS",
        data: res.data
      });
      return res.data
    }).catch(err => {
      return false
    })
  }
}

// Only ACTIVE producer genres are assignable to a user — `/genres` also returns
// the legacy taxonomy, and offering those produced a dropdown where picking an
// entry silently wiped the user's real genres. `/genres/producer` is the same
// set the app's own profile editor uses.
export function getUsersGenre() {
  return dispatch => {
    return axios.get(`api/v1/genres/producer`).then(res => {
      dispatch({
        type: "GET_USER_GENRE",
        data: res.data
      });
      return res.data
    }).catch(err => {
      return false
    })
  }
}
